<template>
    <div>

        <div class="d-flex w-100" v-for="gridRow in gridRows">
            <div v-for="document in gridRow" class="mb-1" :class="dynamicClasses">
                <div class="card shadow-sm h-100" style="max-height: 365px;">

                    <img v-if="imageField && getFeaturedImage(document)" :src="getFeaturedImage(document)"
                         class="card-img-top" :alt="imageField.name">

                    <div class="p-1">
                        <div v-if="titleField" class="card-title">{{fieldValue(document, titleField)}}</div>
                        <div v-if="subTitleField" class="card-subtitle mb-2 text-muted">{{fieldValue(document, subTitleField)}}</div>
                        <div v-if="bodyField" class="card-text" v-html="fieldValue(document, bodyField)"></div>
                    </div>

                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import ViewService from "../../services/ViewService";
    import SelectView from "../../components/SelectView.vue";

    export default {
        name: 'GalleryRenderer',
        components: {SelectView},
        props: {
            view: Object,
            table: Object,
            layout: Object,
            parentTable: Object,
            parentDocument: Object,
            columnCount: {
                type: Number,
                default: 3
            }
        },
        data() {
            return {
                model: webase.model,
                records: []
            }
        },
        computed: {
            dynamicClasses() {
                if (this.columnCount === 1) {
                    return 'w-100'
                } else if (this.columnCount === 2) {
                    return 'w-50'
                } else if (this.columnCount === 3) {
                    return 'w-33'
                }

                return 'w-25'
            },
            titleField() {
                if (this.layout.data.title.field) {
                    return webase.utils.array.get(this.table.fields, this.layout.data.title.field)
                }

                return null
            },
            subTitleField() {
                if (this.layout.data.subTitle.field) {
                    return webase.utils.array.get(this.table.fields, this.layout.data.subTitle.field)
                }

                return null
            },
            bodyField() {
                if (this.layout.data.body.field) {
                    return webase.utils.array.get(this.table.fields, this.layout.data.body.field)
                }

                return null
            },
            primaryField() {
                return webase.utils.table.getPrimaryField(this.table)
            },
            gridRows() {
                return webase.utils.array.listToGrid(this.records, this.columnCount)
            },
            attachment() {
                let field = webase.utils.table.getAttachmentField(this.table)
                return field
            },
            textField() {
                return webase.utils.table.getTextField(this.table)
            },
            selectField() {
                return webase.utils.table.getSelectField(this.table)
            },
            imageField() {

                if (this.layout.data.image.field) {
                    return webase.utils.array.get(this.table.fields, this.layout.data.image.field)
                }

                return null
            }
        },
        mounted() {
            this.loadData()
            webase.eventDispatcher.on('viewUpdated', this.loadData)
        },
        beforeUnmount() {
            webase.eventDispatcher.off('viewUpdated', this.loadData)
        },
        methods: {
            loadData() {
                let viewService = new ViewService()

                viewService.getData(this.view, this.table).then((response) => {
                    this.records = response
                }).catch((message) => {
                    console.log('error loading data from table')
                    console.log(message)
                })
            },
            fieldValue(document, field) {
                return document[field.index]
            },
            getFeaturedImage(record) {

                let imageData = record[this.imageField.index]

                if (imageData !== undefined && imageData !== null && imageData.url) {
                    return imageData.url
                }

                let attachmentData = record[this.attachment.index]

                if (attachmentData === undefined || attachmentData === null || attachmentData.length === 0) {
                    return null
                }

                let firstAttachment = attachmentData[0]

                if (!webase.utils.table.isImage(firstAttachment)) {
                    return null
                }

                let featureImageUrl = firstAttachment.url
                // console.log(featureImageUrl)
                return featureImageUrl
            },
            detailsRoute(documentId) {

                if (webase.utils.table.hasDetailsView(this.table)) {
                    let detailsView = webase.utils.table.getDetailsView(this.table)
                    return {name: 'details-view', params: {view_id: detailsView.id, record_id: documentId}}
                }

                return {name: 'static-details', params: {table_id: this.table.id, record_id: documentId}}
            }
        }
    }
</script>

